export default __webpack_public_path__ + "static/media/marineMax.bc02907a.png";